import './GrandCoursesList.css'
import useGrandCourses from '../../../hooks/useGrandCourses'

import CardInfoSkeleton from '../../../components/CardInfoSkeleton/CardInfoSkeleton';
import CoursesOffers from '../../CoursesPage/CoursesOffers/CoursesOffers';



export default function GrandCoursesList() {

    const {
        academicUnitFilter, 
        activePage, 
        allCourses, 
        error, 
        filterCourses, 
        isLoading, 
        monthFilter, 
        paginatedCourses, 
        setPage, 
        specialtyFilter, 
        PAGE_SIZE
    } = useGrandCourses()

    return (
        <div id='grandes-cursos' className='GrandCoursesList-main-container main-layout-section'>
            <hr className="GrandCoursesList--lineseparator"/>
            <h2 className='GrandCoursesList--title'>Capacitaciones disponibles</h2>


            <section className="coursesPage__section">
                {(error && !isLoading) &&
                    <p style={{ fontSize: 'var(--fs-body)', textAlign: 'center', color:"var(--color-grand-secondary)" }}>
                        {error}
                    </p>
                }

                {(isLoading && !error) &&
                    <div className="course-offers-container">
                        <CardInfoSkeleton height={200} />
                    </div>
                }

                {(!isLoading && !error && allCourses.open) &&
                    <CoursesOffers
                        isGrand
                        data={paginatedCourses(filterCourses(allCourses.open), activePage, PAGE_SIZE)}
                        upcomingCourses={allCourses?.upcomingCourses}
                        displayUpcomingCourses={!monthFilter && !academicUnitFilter && !specialtyFilter}
                        isLoading={isLoading}
                        activePage={activePage}
                        setPage={setPage}
                        totalPages={Math.ceil(filterCourses(allCourses.open)?.length / PAGE_SIZE)}
                        finishedCourses={filterCourses(allCourses.close)}
                    />
                }
            </section>
        </div>
    )

}